export const data = {
    navItems: [
        {
            label: 'Image References',
            link: '/image-references'
        },
        {
            label: 'Product Dimensions',
            link: '/product-dimensions'
        },
        {
            label: 'Glossary',
            link: '/glossary'
        },
        {
            label: 'Resources',
            link: '/resources'
        },
        {
            label: 'Your favourites',
            link: '/favourites'
        },
    ]
}


// WEBPACK FOOTER //
// ./client/components/Sidebar/data.js